import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SaeResetPasswordService } from './sae-reset-password.service';
import { Router } from '@angular/router';
import { AppConstants } from './../../constants/app-constants';
import { DataService } from '../../services/data.service';
import { UserCacheService } from '../../services/user-cache.service';
import { FwcHero,FwcPreloader,FwcAlert } from '../../../../fwc-lib.js';
import { WcsApiService } from 'src/app/common/services/wcs-api-service';
import { SAEBaseComponent } from 'src/app/common/components/sae-base.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sae-reset-password',
    templateUrl: './sae-reset-password.component.html',
    styleUrls: ['./sae-reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SaeResetPasswordComponent extends SAEBaseComponent implements OnInit {
  @Input() content: any;
  @Output() updateUserCache: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetSuccess = new EventEmitter<boolean>();
  resetForm!: UntypedFormGroup;
  submitted = false;
  createMask = true;
  retypeMask = true;
  token: string;
  rule8characterMet = false;
  ruleLowerCharMet = false;
  ruleUpperCharMet = false;
  ruleSpecialMet = false;
  ruleNumberMet = false;
  showPasswordRules = false;
  passwordValidateError = false;
  passwordMatchError = false;
  public contents: any;
  participationId: number;
  storyId: string;
   expiryTime = 10; // 100 seconds
  oneTimeCode = '';
  remainingTime = 10;
  timerInterval: any;
  isResetPasswordSuccess = false;
   announceObs: Subscription;
   pageErrMsg: string = null;
   pageSuccessMsg: string = null;
  displaySpinner = false;
  resetPasswordOutput = {
    newPassword: '',
    retypePassword: ''
  };
  public userId;

  constructor(
    public wcsApiService: WcsApiService,
    public formBuilder: UntypedFormBuilder,
    public activatedRoute: ActivatedRoute,
    public saeResetPasswordService: SaeResetPasswordService,
    public router: Router,
    public dataService: DataService,
    public userCacheService: UserCacheService
  ) { super(wcsApiService);
    const fwcHero = new FwcHero();
    fwcHero.build();
    const fwcPreloader = new FwcPreloader();
    fwcPreloader.build();
    const fwcAlert = new FwcAlert();
    fwcAlert.build();
  }

  async ngOnInit(): Promise<void> {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params.token;
    });

    this.participationId = parseInt(this.activatedRoute.snapshot.paramMap.get('id'));
    this.storyId = this.activatedRoute.snapshot.paramMap.get('storyId');

    this.resetForm = this.formBuilder.group({
      newPassword: ['', Validators.required],
      retypePassword: ['', Validators.required]
    });
    await this.loadWCSData('login');
    if (this.wcsdata) {
    this.contents = this.wcsdata;
  }
  const state = history.state;
    if (state && state.userId) {
      this.userId = state.userId;
    
    }
    this.announceObs = this.dataService.announcement.subscribe(announce => {
      if (announce === null) {
        this.pageErrMsg = null;
      } else if (announce != null && announce.topic === AppConstants.RESET_PD_FAILED) {
        this.pageErrMsg = announce.message;
      }else if(announce != null && announce.topic === AppConstants.RESET_PD_SUCCESS){
        this.pageSuccessMsg = announce.message;
      }
    });
  }

  get form(): { [p: string]: AbstractControl } { return this.resetForm.controls; }

  onChangePassword(): void {
    this.submitted = true;

    this.dataService.doAnnouncement(null);
    if (this.resetForm.status !== AppConstants.INVALID_STATUS) {
      this.updateUserCache.emit(this.resetPasswordOutput);
    }
    if (this.submitted && !this.form.newPassword.errors && this.validateFields()) {
      this.displaySpinner = true;
      this.saeResetPasswordService.resetOktaPassword(this.userId, this.form.newPassword.value).subscribe(data => {
        const response: any = data;
          this.displaySpinner = false;
        if (response.status === AppConstants.FAILURE_STATUS) {
            this.dataService.doAnnouncement({topic: AppConstants.RESET_PD_FAILED, message: this.contents.errorCode.RESET_PASS_101});
            this.navigateTo();
        } else if (response.status === AppConstants.SUCCESS_STATUS) {
          
          // const participationId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
          // const participationId = parseInt(this.activatedRoute.snapshot.paramMap.get("id"));
           this.isResetPasswordSuccess=true;
           this.remainingTime = this.expiryTime;
          this.startTimer();
          this.dataService.doAnnouncement({topic: AppConstants.RESET_PD_SUCCESS, message: this.contents.errorCode.RESET_PASS_102});
          this.resetSuccess.emit(true);
        }
      }, err => {
         this.displaySpinner = false;
      });
    }
  }

  
  startTimer(): void {
    this.stopTimer();
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime <= 0) {
        this.stopTimer();
      }
    }, 1000);
  }
  stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      // Navigate to login when timer expires
      if (this.remainingTime <= 0) {
        this.navigateTo();
      }
    }
  }
  validateFields(): boolean {
    let returnVal = true;
    this.passwordMatchError = false;
    this.passwordValidateError = false;

    if (!this.passwordMatch(this.form.newPassword.value, this.form.retypePassword.value)) {
      this.passwordMatchError = true;
      returnVal = false;
    }

    if (!this.passwordValidation(this.form.newPassword.value)) {
      this.passwordValidateError = true;
      returnVal = false;
    }
    return returnVal;
  }

  passwordMatch(newPassword: string, retypePassword: string): boolean {
    if (newPassword != null && retypePassword != null && newPassword === retypePassword) {
      return true;
    } else {
      return false;
    }
  }

  passwordValidation(newPassword): boolean {
    //one lower char, one upper char, one digit, one special character from [$!@*?|], can contain characters from before mentioned only, min = 8, max = 20
    const generalRules = (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$!@*?|])[A-Za-z\d$!@*?|]{12,20}$/);
    //cannot contain whitespaces
    const validateNoSpace = /^\S*$/;
    if (generalRules.test(newPassword) && validateNoSpace.test(newPassword)) {
      return true;
    } else {
      return false;
    }
  }

  checkPasswordRules(): void {
    // pass input value here and check against password rules
    this.showPasswordRules = true;
    this.ruleLowerCharMet = false;
    this.rule8characterMet = false;
    this.ruleUpperCharMet = false;
    this.ruleSpecialMet = false;
    this.ruleNumberMet = false;
    this.ruleUpperCharMet = false;

    if (/[0-9]/g.test(this.form.newPassword.value)) {
      this.ruleNumberMet = true;
    }
    if (/[a-z]/g.test(this.form.newPassword.value)) {
      this.ruleLowerCharMet = true;
    }
    if (/[A-Z]/g.test(this.form.newPassword.value)) {
      this.ruleUpperCharMet = true;
    }
    if (/[$!@*?|]/g.test(this.form.newPassword.value)) {
      this.ruleSpecialMet = true;
    }
    if (/.{12,}/.test(this.form.newPassword.value)) {
      this.rule8characterMet = true;
    }
    if (/[A-Z]/g.test(this.form.newPassword.value)) {
      this.ruleUpperCharMet = true;
    }
  }

  onKey(e): void {
    const regxStr = new RegExp('^[0-9a-zA-Z$!@*?|]*$');
    if (!regxStr.test(e.key)) {
      e.preventDefault();
    }
  }
 closeErrModal() {
        this.pageErrMsg = null;
    }

      closeSuccessModal() {
        this.pageSuccessMsg = null;
    }
  navigateTo(){
    if(this.participationId){
      this.router.navigate([ this.participationId + '/login'], { replaceUrl: true });
    }else if(this.storyId){
      this.router.navigate(['school/'+this.storyId + '/login'], { replaceUrl: true });
    }
  }
}
